const locale = "cs-CZ";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD.MM.YYYY",
	dateTimeFormat: "DD.MM.YYYY HH:mm",
	"serviceReports.headline": "Servisní zprávy",
	"serviceReports.sublineMachine": "Prohlédněte si servisní zprávy k Vašemu stroji a stáhněte si je.",
	"serviceReports.technicianName": "Jméno servisního technika",
	"serviceReports.machineNameAndNumber": "Stroj & číslo stroje",
	"serviceReports.startDate": "Od",
	"serviceReports.endDate": "Do",
	"serviceReports.creationDate": "Datum vytvoření",
	"serviceReports.openReport": "Otevřít servisní zprávu (PDF)",
	"serviceReports.filter": "Filtr",
	"serviceReports.missionNumber": "Číslo zásahu",
	"serviceReports.assignmentType": "Typ servisní zprávy",
	"serviceReports.reportTypes.IA": "Zpráva o deinstalaci / přemístění",
	"serviceReports.reportTypes.AC": "Zpráva o aplikační konzultaci",
	"serviceReports.reportTypes.IV": "Zpráva o přípravě instalace",
	"serviceReports.reportTypes.BA": "Zpráva o hodnocení",
	"serviceReports.reportTypes.UV": "Zpráva o bezpečnostní kontrole",
	"serviceReports.reportTypes.IG": "Zpráva o instalaci použitého stroje",
	"serviceReports.reportTypes.UB": "Zpráva o míře kvality",
	"serviceReports.reportTypes.PN": "Zpráva o asistenci výroby",
	"serviceReports.reportTypes.NR": "Zpráva o dovybavení",
	"serviceReports.reportTypes.IB": "Installation / Start-up report",
	"serviceReports.reportTypes.II": "Zpráva o integraci instalace",
	"serviceReports.reportTypes.IC": "Zpráva o interní opravě",
	"serviceReports.reportTypes.MB": "Zpráva o službě výstavní prodej",
	"serviceReports.reportTypes.HW": "Zpráva o zdroji",
	"serviceReports.reportTypes.TT": "Zpráva o školení technika",
	"serviceReports.reportTypes.SK": "Zpráva o školení zákazníků",
	"serviceReports.reportTypes.RP": "Zpráva o opravě",
	"serviceReports.reportTypes.RW": "Zpráva o opravě a údržbě",
	"serviceReports.reportTypes.WA": "Zpráva o údržbě",
	"serviceReports.reportTypesPlural.IA": "Zprávy o deinstalaci / přemístění",
	"serviceReports.reportTypesPlural.AC": "Zprávy o aplikační konzultaci",
	"serviceReports.reportTypesPlural.IV": "Zprávy o přípravě instalace",
	"serviceReports.reportTypesPlural.BA": "Zprávy o hodnocení",
	"serviceReports.reportTypesPlural.UV": "Zprávy o bezpečnostní kontrole",
	"serviceReports.reportTypesPlural.IG": "Zprávy o instalaci použitého stroje",
	"serviceReports.reportTypesPlural.UB": "Zprávy o míře kvality",
	"serviceReports.reportTypesPlural.PN": "Zprávy o asistenci výroby",
	"serviceReports.reportTypesPlural.NR": "Zprávy o dovybavení",
	"serviceReports.reportTypesPlural.IB": "Installation / Start-up reporte",
	"serviceReports.reportTypesPlural.II": "Zprávy o integraci instalace",
	"serviceReports.reportTypesPlural.IC": "Zprávy o interní opravě",
	"serviceReports.reportTypesPlural.MB": "Zprávy o službě výstavní prodej",
	"serviceReports.reportTypesPlural.HW": "Zprávy o zdroji",
	"serviceReports.reportTypesPlural.TT": "Zprávy o školení technika",
	"serviceReports.reportTypesPlural.SK": "Zprávy o školení zákazníků",
	"serviceReports.reportTypesPlural.RP": "Zprávy o opravě",
	"serviceReports.reportTypesPlural.RW": "Zpráva o opravách a údržbě",
	"serviceReports.reportTypesPlural.WA": "Zprávy o údržbě",
	"serviceReports.loadMore": "Načíst více",
	"serviceReports.loadError": "Při načítání dat došlo k chybě",
	"serviceReports.noReportsFound": "V současné době nejsou k dispozici žádné servisní zprávy.",
	"serviceReports.noReportsAvailable": "V současné době nejsou k dispozici žádné servisní zprávy.",
	missingAuthorization: "Chybějící oprávnění",
	"headline.createCase": "Založit nový servisní případ",
	"headline.caseDetails": "Detaily případu",
	"headline.contactData": "Kontaktní data",
	"field.reason.label": "Důvod hlášení",
	"field.machine.label": "Stroj & číslo stroje",
	"field.softwareProblemClassification.label": "Klasifikace problému",
	"field.softwareInstallationProblem.label": "Problém s instalací",
	"field.softwareLicenseIssue.label": "Problém s licencí",
	"field.softwareType.label": "Typ softwaru",
	"field.softwareModule.label": "Softwarový modul",
	"field.errorNumber.label": "Čísla chyb",
	"field.errorNumber.explanation": "např. 0000FC00, 1.10.58102409 nebo 6000",
	"field.errorNumber.addAnotherNumber": "přidat další číslo chyby",
	"field.errorNumber.errorMessage": "Neplatné číslo chyby",
	"field.message.label": "Zpráva",
	"field.message.placeholder": "Popište prosím (bez pozdravení) Vaši žádost / problém tak konkrétně jak je možné a podrobně jak je potřeba. Děkujeme.",
	"field.fileUpload.label": "Přílohy",
	"field.fileUpload.info": "Povolené formáty souborů: IMG, JPG, PNG, PDF, HTML, soubory TruTops atd. (max. 16 MB) a MP4 video soubory (max. 50 MB)",
	"field.salutation.label": "Oslovení",
	"field.salutation.male": "Pan",
	"field.salutation.female": "Paní",
	"field.firstName.label": "Jméno",
	"field.lastName.label": "Příjmení",
	"field.email.label": "E-Mail",
	"field.phone.label": "Telefonní číslo",
	"button.submit": "Odeslat",
	"button.cancel": "Zrušit",
	"button.back": "zpět",
	"button.next": "dále",
	"button.close": "Zavřít",
	"button.ok": "Ok",
	"auth.error": "Vyskytla se nečekaná chyba.",
	"select.placeholder": "Zvolte ...",
	"validation.requiredField": "Toto pole je povinné",
	"validation.invalidEmail": "Zadejte prosím platnou e-mailovou adresu",
	"validation.maxAllowedCharacters": "Maximálně povolený počet znaků: {{number}}",
	"validation.requiredFieldsExplanation": "Povinná pole jsou označena *.",
	"validation.invalidPhoneNumber": "Zadejte prosím platné telefonní číslo.",
	"softwareProblemClassification.standstill": "Nečinnost",
	"softwareProblemClassification.fault": "Porucha",
	"softwareProblemClassification.slightImpairment": "Lehká závada",
	"softwareProblemClassification.generalInquiry": "Obecný dotaz",
	"serviceCase.proactiveCaseClosure.title": "Zpětná vazba & požadavek uzavření případu",
	"serviceCase.proactiveCaseClosure.instructions": "Pro požadování uzavření případu a abyste nám pomohli zlepšit naši službu Predictive Service, Vás zdvořile žádáme o Vaši zpětnou vazbu.",
	"serviceCase.proactiveCaseClosure.question.submit": "Odeslat",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Požadováno uzavření případu. Děkujeme za Vaši zpětnou vazbu.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "Vyskytla se hlášená anomálie na Vašem stroji?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Byl k dispozici technický návod?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Mohli jste problém sami vyřešit pomocí technického/ých návodu/ů?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Chcete pozastavit zprávy pro tento druh anomálie?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Na jak dlouho chcete pozastavit zprávy pro tento druh anomálie?",
	"serviceCase.proactiveCaseClosure.question.comment": "Vysvětlete prosím, proč chcete pozastavit zprávy pro tento druh anomálie:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Komentář je povinný k požadování uzavření případu a zaslání zpětné vazby",
	"serviceCase.proactiveCaseClosure.answers.yes": "Ano",
	"serviceCase.proactiveCaseClosure.answers.no": "Ne",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 dny",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 dny",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 dny",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 dny",
	"sisConnector.success.headline": "Servisní případ byl úspěšně založen.",
	"sisConnector.success.orderNumberRequired.title": "Upozornění:",
	"sisConnector.success.orderNumberRequired.text": "Přidejte na stránce s detaily případu objednací číslo pro vyúčtování případu a další služby.",
	"sisConnector.success.technicalGuide.title": "Pro to(a)to číslo(a) chyb(y) je k dispozici technický návod.",
	"sisConnector.success.technicalGuide.text": "Na základě uvedeného čísla chyby (čísel chyb) mohl být nalezen technický návod nebo více technických návodů. V cca 50% případů jste nyní schopni Váš problém sami vyřešit. Tato funkce je k dispozici pouze s odpovídající servisní smlouvou.",
	"sisConnector.success.outsideOfServiceHours": "Respektujte prosím, že případy vytvořené mimo naši provozní dobu servisu nebyly zpracovány.",
	"sisConnector.success.serviceTimes.MonFri": "Provozní doba našeho servisu je: pondělí až pátek",
	"sisConnector.success.serviceTimes.Sat": "a sobota",
	"sisConnector.success.withTechnicalServiceHotline": "Pokud potřebujete okamžitou pomoc, zavolejte prosím pro získání podpory technický servis TRUMPF ({{hotline}}).",
	"sisConnector.success.withoutTechnicalServiceHotline": "Pokud potřebujete okamžitou pomoc, zavolejte prosím pro získání podpory technický servis TRUMPF.",
	"sisConnector.success.caseId": "Číslo případu",
	"sisConnector.failed.headline": "Servisní případ nebylo možné založit.",
	"sisConnector.failed.unknownError": "Zkuste to prosím znovu nebo se obraťte na svou podporu."
};
var csCZ = {
	locale: locale,
	translations: translations
};

export { csCZ as default, locale, translations };
//# sourceMappingURL=cs-CZ-BGA6zQTA.js.map

//# sourceMappingURL=cs-CZ-BGA6zQTA.js.map